import React, { useState, useEffect } from 'react'
import { getCurrentDate } from '../../Utils/Dateutils';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox
} from '@mui/material';
import TitleBar from '../TitleBar';
import { ReceiptMenu, ReportMenu } from '../TitleList';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';
import RadioComponent from '../FieldsComponents/RadioComponent';
import TextareaComponent from '../FieldsComponents/TextareaComponent';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm,selectParty } from '../Selectors/Master/ItemSelectors';
import { fetchPartyData } from '../../Store/PHPSlice/Party';


const SalesLedgerStatement = () => {

    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        partyType: '',
        partyNm: '',
        fromDt: '',
        toDt: '',
        cat: 'DATE',
        stmtView:'RECEIPT',
        userId: userdata?.ID
    });

    const dispatch = useDispatch();
    const firmList = useSelector(selectFirm);
    const partyList = useSelector(selectParty);
    

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
    }, [dispatch]);


    const isDesktop = useMediaQuery('(min-width:768px)');
   const handleDateChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
        ...prev,
        [name]: value   // ✅ updates only fromDt OR toDt
    }));
};


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const dropdownlistfirst = [
        {
            label: 'Firm Name',
            id: 'firmId',
            options: firmList?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
       
        {
            label: 'Party Name',
            id: 'partyNm',
            options: partyList?.data || [],   // ✅ FIX
            value: formData.partyNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'partyNm', value: newValue ? newValue.ID : '' } }, 'partyNm'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
       

    ];

    const dateFields = [
        { label: 'From Date', name: 'fromDt', type: 'date' },
        { label: 'To Date', name: 'toDt', type: 'date' }

    ];
    const ledgerSequenceOptions = [
    { label: 'Date Wise', value: 'DATE' },
    { label: 'Bill No Wise', value: 'BILL' }
];
 const ledgerStmtView = [
    { label: 'Receipt Wise', value: 'RECEIPT' },
    { label: 'Settlement Receipt Wise', value: 'SETTLEMENT' }
];
const handleRadioChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
        ...prev,
        [name]: value      // ✅ works for both cat & stmtView
    }));
};

// const handleSearch = () => {
//     const params = new URLSearchParams({
//         firmId: formData.firmId || '',
//         partyNm: formData.partyNm || '',
//         fromDt: formData.fromDt || '',
//         toDt: formData.toDt || '',
//         cat: formData.cat || '',
//         userId: formData.userId || ''
//     }).toString();

//     const url = `/salesLedgerPrint/${firmId}/${partyNm}/${fromDt}/${toDt}/${cat}`;

//     window.open(url, '_blank');
// };
const handleSearch = () => {
   // alert(formData.stmtView);
    if (!formData.firmId) {
        alert('Please select Firm Name');
        return; // ❌ stop execution
    }
     else if (!formData.partyNm) {
        alert('Please select Party Name');
        return; // ❌ stop execution
    }
     else if (!formData.fromDt) {
        alert('Please select From Date');
        return; // ❌ stop execution
    }

    const width = 1200;
    const height = 700;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
   if(formData.stmtView === "RECEIPT")
   {
    const url = `/SalesLedgerPrint/${formData.firmId}/${formData.partyNm || 0}/${formData.fromDt || 0}/${formData.toDt || 0}/${formData.cat || 0}`;

    window.open(
        url,
        'SalesLedgerPrint',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
    );
}
else if(formData.stmtView === "SETTLEMENT")
{

    const url = `/SettlementSalesLedgerPrint/${formData.firmId}/${formData.partyNm || 0}/${formData.fromDt || 0}/${formData.toDt || 0}/${formData.cat || 0}`;

    window.open(
        url,
        'SettlementSalesLedgerPrint',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
    );
}
};



const handleReset = () => {
    setFormData({
        partyType: '',
        partyNm: '',
        fromDt: '',
        toDt: '',
        cat: 'DATE',
        stmtView:'RECEIPT',
        userId: userdata?.ID
    });
};
    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };



 
    return (
        <>
            <TitleBar data={ReportMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Party Wise Sales Ledger Statement</h2>


                <Grid container spacing={2}>
                    <Grid item xs={12}>
                       <Paper style={{ padding: '2vh' }}>
    <Grid container spacing={1}>

        {/* Dropdowns */}
        {dropdownlistfirst.map((drop) => (
            <Dropdown
                key={drop.label}
                label={drop.label}
                id={drop.id}
                options={drop.options}
                value={drop.value}
                onChange={drop.onChange}
                isDesktop={isDesktop}
                getOptionLabel={drop.getOptionLabel}
                isOptionEqualToValue={drop.isOptionEqualToValue}
                valueFinder={drop.valueFinder}
            />
        ))}

        {/* Date Fields */}
        {dateFields.map((field) => (
            <DateInputComponent
                key={field.name}
                formData={formData}
                handleDateChange={handleDateChange}
                handleInputChange={handleInputChange}
                styled={styled}
                inputStyles={inputStyles}
                isDesktop={isDesktop}
                field={field}
            />
        ))}

        {/* Ledger Sequence By */}
       <Grid item xs={12} >
    <FormControl
        component="fieldset"
        sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
    >
        <Typography variant="subtitle2" sx={{ mr: 2 }} style={{paddingRight:"50px"}}>
            Ledger Sequence By :
        </Typography>

        <RadioComponent
            name="cat"
            value={formData.cat}
            onChange={handleRadioChange}
            options={ledgerSequenceOptions}
            row
        />
          <Typography variant="subtitle2" sx={{ mr: 2 }} style={{paddingRight:"50px"}}>
            Ledger Statement View :
        </Typography>

        <RadioComponent
            name="stmtView"
            value={formData.stmtView}
            onChange={handleRadioChange}
            options={ledgerStmtView}
            row
        />
    </FormControl>
</Grid>


        {/* Search & Reset Buttons */}
        <Grid
            item
            xs={12}
            
            sx={{
                display: 'flex',
                alignItems: 'flex-end',
                gap: 2,
                mt: { xs: 1, md: 3 }
            }}
        >
            <Button
                variant="contained"
                color="primary"
                onClick={handleSearch}
            >
                Search
            </Button>

            <Button
                variant="outlined"
                color="secondary"
                onClick={handleReset}
            >
                Reset
            </Button>
        </Grid>

    </Grid>
</Paper>

                    </Grid>
                </Grid>

            </div>
        </>
    )
}

export default SalesLedgerStatement;
